import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartsCarouselComponent } from './charts-carousel.component';


import { BarChartReadModule } from '../bar-chart-read/bar-chart-read.module';
import { BarChartAnsweredModule } from '../bar-chart-answered/bar-chart-answered.module';
import { DonutChartModule } from '../donut-chart/donut-chart.module';
import { CarouselModule } from 'ngx-bootstrap/carousel';

@NgModule({
  imports: [
    CommonModule,
    CarouselModule.forRoot(),


    DonutChartModule, BarChartReadModule, BarChartAnsweredModule,
  ],
  declarations: [ChartsCarouselComponent],
  exports: [ChartsCarouselComponent],
})
export class ChartsCarouselModule { }
